import * as Yup from 'yup';

const schema = Yup.object().shape({
  company_key: Yup.string().required('Este campo é obrigatório'),
  branch_key: Yup.string().required('Este campo é obrigatório'),
});

export default schema;
